var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-btn',{staticClass:"suboverlineCapsReg",attrs:{"color":_vm.btnColor,"elevation":"0","text":"","block":""},on:{"click":_vm.callAction}},[_vm._v(" "+_vm._s(_vm.btnText)+" ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }